module.exports = __webpack_public_path__ + "static/media/BeVietnamPro-Medium.051f452d.ttf";